import { useContext } from "react";
import { IndexingContext } from "./IndexingContext";

export function useIndex() {
  return useContext(IndexingContext);
}
